import React from 'react';

import {Modal, RoundButton, zIndex} from '@optimaxdev/design-system';
import {connect} from 'react-redux';

import {ApplicationStoreType} from 'desktop/store';

import {toggleCaliforniaPrepositionPopup} from '../../store/reducers/showCaliforniaPrepositionPopup/showCaliforniaPrepositionPopup';
import {getIsShowCaliforniaPrepositionPopUp} from '../../store/selectors/deliveryStep/deliveryStep';

import s from './californiaPropositionPopup.scss';

type PropsType = {
    isCaliforniaPropositionPopupVisible: boolean;
    toggleCaliforniaPopup: () => void;
};

/**
 * California Preposition Popup Component
 *
 * @constructor
 */
const CaliforniaPropositionPopup: React.FC<PropsType> = ({
    isCaliforniaPropositionPopupVisible,
    toggleCaliforniaPopup,
}) => (
    <Modal
        isOpen={isCaliforniaPropositionPopupVisible}
        onRequestClose={toggleCaliforniaPopup}
        overlay="dark"
        zIndex={zIndex.popup}
    >
        <div className={s.container}>
            <h2 className={s.title}>CALIFORNIA PROPOSITION 65 WARNING:</h2>
            <p className={s.text}>
                The product(s) in this order may expose you to Bisphenol A (BPA) and Methimazole
                which are known to the State of
                <br /> California to cause birth defects or other
                <br /> reproductive harm.
            </p>
            <p className={s.text}>
                The item(s) in this order can also expose you to Nickel which is known to the State
                of California to cause cancer.
            </p>
            <p className={s.text}>
                For further information go to:{' '}
                <a
                    className={s.link}
                    href="https://www.p65warnings.ca.gov/"
                    rel="noopener noreferrer"
                    target="_blank"
                >
                    www.P65Warnings.ca.gov
                </a>
            </p>
            <div className={s.close}>
                <RoundButton onClick={toggleCaliforniaPopup} size="small" type="button">
                    Close
                </RoundButton>
            </div>
        </div>
    </Modal>
);

/**
 * Map state to props
 * @param {ApplicationStoreType} state - redux store
 * @returns {PropsType} props
 */
const mapStateToProps = (state: ApplicationStoreType) => ({
    isCaliforniaPropositionPopupVisible: getIsShowCaliforniaPrepositionPopUp(state),
});

const mapDispatchToProps = {
    toggleCaliforniaPopup: toggleCaliforniaPrepositionPopup,
};

export const CaliforniaPropositionPopupConnected = connect(
    mapStateToProps,
    mapDispatchToProps,
)(CaliforniaPropositionPopup);
